import { renderContent } from "@/lib/htmlContentHelpers";

type InteractionDescriptionContentProps = {
  content: string | null | undefined;
  className?: string;
};

/**
 * View-only interaction description. Detects pasted markdown vs plain notes
 * so **bold** renders as emphasis without rewriting ordinary staff text.
 */
export default function InteractionDescriptionContent({ content, className }: InteractionDescriptionContentProps) {
  return (
    <div data-testid="interaction-description-content" className={className}>
      {renderContent(content, { detectMarkdown: true, enhancedCleanup: false, allowHtml: false })}
    </div>
  );
}
